<div class="p-card" style="overflow: hidden; height: 100%;">

  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <h3 class="mr-3">Trust Builder</h3>

    <div class="flex gap-2">
      <button pButton
              type="button"
              label="Trust Report"
              (click)="activeTab = 'report'"
              color="primary"
              style="background: var(--main-ui-color); color: var(--app-highlight-text);"
              [class.p-button-outlined]="activeTab !== 'report'"></button>

      <button pButton
              type="button"
              label="TrustBuilder Forms"
              (click)="activeTab = 'forms'"
              color="primary"
              style="background: var(--main-ui-color); color: var(--app-highlight-text);"
              [class.p-button-outlined]="activeTab !== 'forms'"></button>

      <button pButton
              type="button"
              label="External Trust Page"
              (click)="activeTab = 'external'"
              color="primary"
              style="background: var(--main-ui-color); color: var(--app-highlight-text);"
              [class.p-button-outlined]="activeTab !== 'external'"></button>
    </div>
  </div>


  <div *ngIf="activeTab === 'report'" style="overflow: auto; height: 100%;">

    <div style="overflow: hidden; height: 100%;">
      <div class="p-card-header flex p-3 gap-2 align-items-center">
        <h3 class="mr-3">Trust Report</h3>
        <p-select *ngIf="trustReport && trustReports"
                  [options]="trustReports"
                  optionLabel="name"
                  [ngModel]="trustReport"
                  (ngModelChange)="onTrustReportChanged($event)">
        </p-select>

        <div class="flex align-items-center">
          <p-button [text]="true"
                    pTooltip="Create New"
                    icon="pi pi-plus"
                    (click)="createTrustReport()">
          </p-button>

          <p-button *ngIf="trustReport"
                    [text]="true"
                    pTooltip="Duplicate"
                    icon="pi pi-copy"
                    (click)="duplicateTrustReport()">
          </p-button>

          <p-button *ngIf="trustReport"
                    [text]="true"
                    pTooltip="Edit"
                    icon="pi pi-pencil"
                    (click)="editTrustReport(trustReport)">
          </p-button>

          <p-button *ngIf="trustReport"
                    [text]="true"
                    pTooltip="Delete"
                    icon="pi pi-trash"
                    severity="danger"
                    mwlConfirmationPopover
                    [title]="'Delete Selected Trust Report'"
                    [popoverMessage]="'You are going to delete the selected Trust Report. Are you sure?'"
                    [appendToBody]="true"
                    [confirmText]="'Yes'"
                    [cancelText]="'No'"
                    placement="bottom"
                    (confirm)="removeTrustReport()">
          </p-button>
        </div>
      </div>
      <mat-tab-group>
        <mat-tab label="Trust Builder">
          <div class="scrollable-step-content" style="display: flex; flex-direction: column;" id="sapProfileLayoutDiv"
               *ngIf="trustReport" [formGroup]="formGroup">
            <mat-horizontal-stepper [linear]="false">

              <mat-step label="Frameworks & Topics" [stepControl]="{invalid: false}">

                <div>
                  <mat-form-field appearance="fill" style="width: 50%;">
                    <mat-label>Report Title</mat-label>
                    <input matInput [formControl]="formGroup.get('title')" (input)="logTitle()">

                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field appearance="fill" style="width: 50%;">
                    <mat-label>Report Subtitle</mat-label>
                    <input matInput [formControl]="formGroup.get('subtitle')" (input)="logTitle()">

                  </mat-form-field>
                </div>
                <div>
                  <mat-checkbox formControlName="isPublished">Make Available as Live Page</mat-checkbox>
                </div>

                <div style="display: flex; gap: 2rem;">

                  <div style="flex: 1;" formArrayName="frameworks">
                    <h4 class="mb-2">Select Frameworks</h4>
                    <div style="display: flex; flex-wrap: wrap; gap: 1rem;">
                      <div *ngFor="let frameworkCtrl of getFrameworks(); let i = index"
                           style="border: 2px solid #ccc; padding: 5px; border-radius: 8px; cursor: pointer;"
                           [style.border-color]="frameworkCtrl.value.selected ? '#007ad9' : '#ccc'"
                           (click)="toggleFrameworkSelection(i)">
                        <img [src]="frameworkCtrl.value.imageUrl" [alt]="frameworkCtrl.value.name"
                             style="width: 80px; height: 80px; object-fit: cover;" />
                      </div>
                    </div>
                    <button mat-stroked-button color="primary" style="margin-top:10px;"
                            (click)="openUploadFrameworkDialog()">
                      Upload Framework
                    </button>
                  </div>

                  <div style="flex: 1;" formArrayName="controlCategories">
                    <h4 class="mb-2">Select Control Categories</h4>
                    <div *ngFor="let catCtrl of getControlCategories(); let j = index" style="margin-bottom: 0.5rem;">
                      <mat-checkbox [checked]="catCtrl.value.selected"
                                    (change)="toggleControlCategorySelection(j)">
                        {{ catCtrl.value.name }}
                      </mat-checkbox>
                    </div>
                    <button mat-stroked-button color="primary" style="margin-top:10px;"
                            (click)="openAddCategoryDialog()">
                      Add Control Category
                    </button>
                  </div>


                </div>

                <div style="margin-top: 2rem;">
                  <button mat-raised-button matStepperPrevious type="button">Back</button>
                  <button mat-raised-button matStepperNext type="button">Next</button>
                  <button mat-raised-button (click)="onDone()">Save</button>
                </div>

              </mat-step>

              <!--Customize Controls-->

              <mat-step label="Customize" [stepControl]="{ invalid: false }" style="overflow: visible;">

                <ng-container *ngIf="getControlCategoriesFA().length > 0; else noSelection">
                  <div class="mb-4">
                    <input type="file"
                           accept=".csv"
                           (change)="onCsvUpload($event)"
                           style="display:none"
                           #csvInput>
                    <button mat-stroked-button color="primary" (click)="csvInput.click()">
                      Upload Controls CSV
                    </button>
                  </div>

                  <mat-accordion [formGroup]="formGroup">
                    <div formArrayName="controlCategories">
                      <!-- iterate the real FormArray controls so formGroupName indices match -->
                      <div *ngFor="let category of getControlCategoriesFA().controls; let catIdx = index"
                           [formGroupName]="catIdx">
                        <mat-expansion-panel *ngIf="category.get('selected')?.value" [expanded]="true">
                          <mat-expansion-panel-header>
                            <mat-panel-title>{{ category.get('name')?.value }}</mat-panel-title>
                            <p-button [text]="true"
                                      pTooltip="Delete Category"
                                      icon="pi pi-trash"
                                      severity="danger"
                                      mwlConfirmationPopover
                                      [title]="'Delete Category'"
                                      [popoverMessage]="'Are you sure you want to delete this category?'"
                                      [appendToBody]="true"
                                      [confirmText]="'Yes'"
                                      [cancelText]="'No'"
                                      placement="bottom"
                                      (confirm)="deleteCategory(catIdx)">
                            </p-button>
                          </mat-expansion-panel-header>

                          <div class="flex align-items-center mb-3">
                            <p-button [text]="true"
                                      pTooltip="Add Control Item"
                                      icon="pi pi-plus"
                                      (click)="openAddControlItemDialog(category.get('name')?.value)">
                            </p-button>
                          </div>

                          <!-- control items -->
                          <div formArrayName="controlItems">
                            <div *ngFor="let item of getControlItems(catIdx).controls; let i = index"
                                 [formGroupName]="i" class="control-item">
                              <div class="flex justify-between items-center">
                                <div>
                                  <strong>{{ item.get('title')?.value }}</strong>
                                  <p>{{ item.get('description')?.value }}</p>
                                </div>
                                <p-button [text]="true"
                                          pTooltip="Delete Control Item"
                                          icon="pi pi-trash"
                                          severity="danger"
                                          mwlConfirmationPopover
                                          [title]="'Delete Control Item'"
                                          [popoverMessage]="'Are you sure you want to delete this control item?'"
                                          [appendToBody]="true"
                                          [confirmText]="'Yes'"
                                          [cancelText]="'No'"
                                          placement="bottom"
                                          (confirm)="deleteControlItem(catIdx, i)">
                                </p-button>
                              </div>


                              <mat-radio-group formControlName="response"
                                               (change)="onResponseChange(catIdx, i, $event)"
                                               [name]="'response-'+catIdx+'-'+i"
                                               class="flex flex-col gap-2">
                                <mat-radio-button value="Yes">Yes</mat-radio-button>
                                <mat-radio-button value="No">No</mat-radio-button>
                                <mat-radio-button value="N/A">N/A</mat-radio-button>
                                <mat-radio-button value="Custom">Custom</mat-radio-button>
                              </mat-radio-group>

                              <mat-form-field *ngIf="getControlItems(catIdx).at(i).get('response')?.value === 'Custom'"
                                              appearance="fill">
                                <input matInput
                                       placeholder="Enter custom response"
                                       formControlName="customResponse"
                                       (click)="$event.stopPropagation()" />
                              </mat-form-field>


                              <!-- evidence section -->
                              <div class="evidence-section mt-3">
                                <div class="flex justify-between items-center">
                                  <strong>Evidence</strong>
                                  <div class="flex gap-2">
                                    <label for="{{'tbciFile' + catIdx + '-' + i}}" class="btn">
                                      <i class="pi pi-plus"></i>
                                      <input id="{{'tbciFile' + catIdx + '-' + i}}" type="file"
                                             accept=".jpg,.png,.pdf"
                                             (change)="onAddEvidenceFile($event, catIdx, i)"
                                             style="display:none;" />
                                    </label>
                                  </div>
                                </div>

                                <!-- List of evidences -->
                                <ul *ngIf="getControlItems(catIdx).at(i).get('evidences')?.value?.length">
                                  <li
                                    *ngFor="let ev of getControlItems(catIdx).at(i).get('evidences')?.value; let evIdx = index"
                                    class="flex justify-between items-center mt-1">
                                    <span>{{ ev.name }}</span>
                                    <button type="button" pButton icon="pi pi-trash" severity="danger" text="true"
                                            (click)="onDeleteEvidence(catIdx, i, evIdx)"
                                            pTooltip="Delete evidence"></button>
                                  </li>
                                </ul>
                              </div>


                              <div class="note-section">
                                <mat-form-field appearance="fill" class="note-field">
                                  <mat-label>Note</mat-label>
                                  <textarea matInput
                                            placeholder="Add a note for this control item"
                                            formControlName="note"
                                            rows="3"></textarea>
                                </mat-form-field>

                                <mat-checkbox formControlName="showNote">
                                  Show note in final report
                                </mat-checkbox>
                              </div>


                            </div>
                          </div>

                        </mat-expansion-panel>
                      </div>
                    </div>
                  </mat-accordion>
                </ng-container>

                <ng-template #noSelection>
                  <p>No control categories selected.</p>
                </ng-template>
                <br /><br />
                <div formGroupName="personnel" class="grid gap-8">
                  <div class="flex items-start gap-6">
                    <div formGroupName="companyOwners" class="flex-1">
                      <h3 class="font-semibold mb-2">Company Owners</h3>
                      <div formArrayName="people">
                        <div
                          *ngFor="let owner of formGroup.get('personnel.companyOwners.people').controls; let i = index"
                          [formGroupName]="i" class="mb-2 flex gap-2">
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" />
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Role</mat-label>
                            <input matInput formControlName="role" />
                          </mat-form-field>
                        </div>
                      </div>
                      <button mat-stroked-button color="primary" (click)="addPersonnel('CompanyOwner')">
                        + Add Owner
                      </button>
                    </div>
                    <div class="flex flex-col items-center gap-2">
                      <img [src]="formGroup.get('personnel.companyOwners.imageUrl')?.value || 'assets/placeholder.png'"
                           alt="Owner Image"
                           style="height: 121px; width: auto; object-fit: contain; border-radius: 8px;" />
                      <button mat-flat-button color="accent" (click)="fileInput1.click()">
                        Change
                      </button>
                      <input type="file" #fileInput1 accept="image/*" style="display:none"
                             (change)="onUploadImage('personnel.companyOwners.imageUrl', $event)" />
                    </div>
                  </div>

                  <div class="flex items-start gap-6">
                    <div formGroupName="complianceAdvisors" class="flex-1">
                      <h3 class="font-semibold mb-2">Compliance Advisors</h3>
                      <div formArrayName="people">
                        <div
                          *ngFor="let owner of formGroup.get('personnel.complianceAdvisors.people').controls; let i = index"
                          [formGroupName]="i" class="mb-2 flex gap-2">
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" />
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Role</mat-label>
                            <input matInput formControlName="role" />
                          </mat-form-field>
                        </div>
                      </div>
                      <button mat-stroked-button color="primary" (click)="addPersonnel('ComplianceAdvisor')">
                        + Add Advisor
                      </button>
                    </div>
                    <div class="flex flex-col items-center gap-2">
                      <img
                        [src]="formGroup.get('personnel.complianceAdvisors.imageUrl')?.value || 'assets/placeholder.png'"
                        alt="Advisor Image"
                        style="height: 121px; width: auto; object-fit: contain; border-radius: 8px;" />
                      <button mat-flat-button color="accent" (click)="fileInput2.click()">
                        Change
                      </button>
                      <input type="file" #fileInput2 accept="image/*" style="display:none"
                             (change)="onUploadImage('personnel.complianceAdvisors.imageUrl', $event)" />

                    </div>
                  </div>

                  <div class="flex items-start gap-6">
                    <div formGroupName="thirdPartyAssessors" class="flex-1">
                      <h3 class="font-semibold mb-2">3rd Party Assessors</h3>
                      <div formArrayName="people">
                        <div
                          *ngFor="let owner of formGroup.get('personnel.thirdPartyAssessors.people').controls; let i = index"
                          [formGroupName]="i" class="mb-2 flex gap-2">
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Name</mat-label>
                            <input matInput formControlName="name" />
                          </mat-form-field>
                          <mat-form-field appearance="fill" class="flex-1">
                            <mat-label>Role</mat-label>
                            <input matInput formControlName="role" />
                          </mat-form-field>
                        </div>
                      </div>
                      <button mat-stroked-button color="primary" (click)="addPersonnel('ThirdPartyAssessor')">
                        + Add 3rd Party Assessor
                      </button>
                    </div>
                    <div class="flex flex-col items-center gap-2">
                      <img
                        [src]="formGroup.get('personnel.thirdPartyAssessors.imageUrl')?.value || 'assets/placeholder.png'"
                        alt="Assessor Image"
                        style="height: 121px; width: auto; object-fit: contain; border-radius: 8px;" />
                      <button mat-flat-button color="accent" (click)="fileInput3.click()">
                        Change
                      </button>
                      <input type="file" #fileInput3 accept="image/*" style="display:none"
                             (change)="onUploadImage('personnel.thirdPartyAssessors.imageUrl', $event)" />
                    </div>

                  </div>


                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Disclaimer</mat-label>
                    <textarea matInput
                              rows="3"
                              placeholder="Enter disclaimer text..."
                              [formControl]="formGroup.get('disclaimer')">
                  </textarea>
                  </mat-form-field>


                </div>


                <div class="step-actions">
                  <button mat-raised-button matStepperPrevious type="button">Back</button>
                  <button mat-raised-button matStepperNext type="button">Next</button>
                  <button mat-raised-button (click)="onDone()">Save</button>
                </div>

              </mat-step>

              <!--Customize Controls-->

              <mat-step label="Documentation" [stepControl]="{ invalid: false }" style="overflow: visible;">
                <mat-accordion style="width: 100%;">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>Policies &amp; Procedures</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div>
                        <mat-form-field style="width: 400px;">
                          <mat-label>Policies &amp; Procedures Note</mat-label>
                          <input matInput [(ngModel)]="trustReport.policiesAndProceduresNote"
                                 [ngModelOptions]="{standalone: true}" />
                        </mat-form-field>
                      </div>
                      <button mat-stroked-button color="primary"
                              (click)="selectDocumentFolder('policiesAndProceduresPath')">
                        Select Folder
                      </button>
                      <h5 style="margin-top: 15px;">
                        {{ trustReport.policiesAndProceduresPath }}
                        <div
                          style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                          @for (file of policiesAndProcedures; track file.name) {
                            <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                              <a target="_blank"
                                 [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                 style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                      <span
                                        style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                style="flex: 0 0 auto;">.{{ file.extension }}</span>
                              </a>
                            </div>
                          }
                        </div>
                      </h5>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>Assessments &amp; Authorizations</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div>
                        <mat-form-field style="width: 400px;">
                          <mat-label>Assessments &amp; Authorizations</mat-label>
                          <input matInput [(ngModel)]="trustReport.assessmentsAndAuthorizationsNote"
                                 [ngModelOptions]="{standalone: true}" />
                        </mat-form-field>
                      </div>
                      <button mat-stroked-button color="primary"
                              (click)="selectDocumentFolder('assessmentsAndAuthorizationsPath')">
                        Select Folder
                      </button>
                      <h5 style="margin-top: 15px;">
                        {{ trustReport.assessmentsAndAuthorizationsPath }}
                        <div
                          style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                          @for (file of assessmentsAndAuthorizations; track file.name) {
                            <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                              <a target="_blank"
                                 [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                 style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                      <span
                                        style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                style="flex: 0 0 auto;">.{{ file.extension }}</span>
                              </a>
                            </div>
                          }
                        </div>
                      </h5>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>Security Plans</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <div>
                        <mat-form-field style="width: 400px;">
                          <mat-label>Assessments &amp; Authorizations</mat-label>
                          <input matInput [(ngModel)]="trustReport.securityPlansNote"
                                 [ngModelOptions]="{standalone: true}" />
                        </mat-form-field>
                      </div>
                      <button mat-stroked-button color="primary"
                              (click)="selectDocumentFolder('securityPlansPath')">
                        Select Folder
                      </button>
                      <h5 style="margin-top: 15px;">
                        {{ trustReport.securityPlansPath }}
                        <div
                          style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                          @for (file of securityPlans; track file.name) {
                            <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                              <a target="_blank"
                                 [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                 style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                      <span
                                        style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                style="flex: 0 0 auto;">.{{ file.extension }}</span>
                              </a>
                            </div>
                          }
                        </div>
                      </h5>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>Plan of Action &amp; Milestones</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <mat-form-field style="width: 400px;">
                        <mat-label>Plan of Action &amp; Milestones Note</mat-label>
                        <input matInput [(ngModel)]="trustReport.planOfActionAndMilestonesNote"
                               [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <div>
                        @if (trustReport.planOfActionAndMilestones) {
                          <img style="max-width: 1054px; max-height: 816px;"
                               [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.planOfActionAndMilestones) + '&asImage=true&tenantName=' + tenantName" />
                        }
                        <label class="mat-button mat-raised-button" for="updatePlanOfActionAndMilestones">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new file</p>
                          <input id="updatePlanOfActionAndMilestones" type="file" accept=".pdf,image/*"
                                 (change)="addFile($event, 'planOfActionAndMilestones')"
                                 name="updatePlanOfActionAndMilestones"
                                 style="display: none;" />
                        </label>
                        @if (settings.planOfActionAndMilestones) {
                          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                 [title]="'Remove Plan of Action &amp; Milestones'"
                                 [popoverMessage]="'You are going to remove Plan of Action &amp; Milestones. Are you sure?'"
                                 [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                 (confirm)="settings.planOfActionAndMilestones=null">
                            <i class="pi pi-trash"></i>
                            <p class="clip-text"> Remove Plan of Action &amp; Milestones</p>
                          </label>
                        }
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>Incident Reports</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <mat-form-field style="width: 400px;">
                        <mat-label>Incident Reports Note</mat-label>
                        <input matInput [(ngModel)]="trustReport.incidentReportsNote"
                               [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <div>
                        @if (trustReport.incidentReports) {
                          <img style="max-width: 1054px; max-height: 816px;"
                               [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.incidentReports) + '&asImage=true&tenantName=' + tenantName" />
                        }
                        <label class="mat-button mat-raised-button" for="updateIncidentReports">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new file</p>
                          <input id="updateIncidentReports" type="file" accept=".pdf,image/*"
                                 (change)="addFile($event, 'incidentReports')"
                                 name="updateIncidentReports"
                                 style="display: none;" />
                        </label>
                        @if (settings.incidentReports) {
                          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                 [title]="'Remove Incident Reports'"
                                 [popoverMessage]="'You are going to remove Incident Reports. Are you sure?'"
                                 [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                 (confirm)="settings.incidentReports=null">
                            <i class="pi pi-trash"></i>
                            <p class="clip-text"> Remove Incident Reports</p>
                          </label>
                        }
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>List of Deployed Authorized Services</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <mat-form-field style="width: 400px;">
                        <mat-label>List of Deployed Authorized Services Note</mat-label>
                        <input matInput [(ngModel)]="trustReport.listOfDeployedAuthorizedServicesNote"
                               [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <div>
                        @if (trustReport.listOfDeployedAuthorizedServices) {
                          <img style="max-width: 1054px; max-height: 816px;"
                               [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.listOfDeployedAuthorizedServices) + '&asImage=true&tenantName=' + tenantName" />
                        }
                        <label class="mat-button mat-raised-button" for="updatelistOfDeployedAuthorizedServices">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new file</p>
                          <input id="updatelistOfDeployedAuthorizedServices" type="file" accept=".pdf,image/*"
                                 (change)="addFile($event, 'listOfDeployedAuthorizedServices')"
                                 name="updatelistOfDeployedAuthorizedServices"
                                 style="display: none;" />
                        </label>
                        @if (settings.listOfDeployedAuthorizedServices) {
                          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                 [title]="'Remove Logo'"
                                 [popoverMessage]="'You are going to remove List of Deployed Authorized Services. Are you sure?'"
                                 [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                 (confirm)="settings.listOfDeployedAuthorizedServices=null">
                            <i class="pi pi-trash"></i>
                            <p class="clip-text"> Remove List of Deployed Authorized Services</p>
                          </label>
                        }
                      </div>
                    </div>
                  </mat-expansion-panel>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>List of Additional Information</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                      <mat-form-field style="width: 400px;">
                        <mat-label>Additional Information Note</mat-label>
                        <input matInput [(ngModel)]="trustReport.additionalInformationNote"
                               [ngModelOptions]="{standalone: true}" />
                      </mat-form-field>
                      <div>
                        @if (trustReport.additionalInformation) {
                          <img style="max-width: 1054px; max-height: 816px;"
                               [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.additionalInformation) + '&asImage=true&tenantName=' + tenantName" />
                        }
                        <label class="mat-button mat-raised-button" for="updateadditionalInformation">
                          <i class="pi pi-paperclip"></i>
                          <p class="clip-text">Upload new file</p>
                          <input id="updateadditionalInformation" type="file" accept=".pdf,image/*"
                                 (change)="addFile($event, 'additionalInformation')"
                                 name="updateadditionalInformation"
                                 style="display: none;" />
                        </label>
                        @if (settings.additionalInformation) {
                          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                                 [title]="'Remove Logo'"
                                 [popoverMessage]="'You are going to remove Additional Information. Are you sure?'"
                                 [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                                 (confirm)="settings.trustReportLogo=null">
                            <i class="pi pi-trash"></i>
                            <p class="clip-text"> Remove Additional Information</p>
                          </label>
                        }
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>


                <div class="step-actions" style="margin-top: 35px;">
                  <button mat-raised-button matStepperPrevious type="button">Back</button>
                  <button mat-raised-button matStepperNext type="button">Next</button>
                  <button mat-raised-button (click)="onDone()">Save</button>
                </div>
              </mat-step>


              <!-- View Report  -->

              <mat-step label="View Report" [stepControl]="{invalid: false}">
                <div class="report-view">
                  <h1>{{ formGroup.value.title }}</h1>
                  <h3>{{ formGroup.value.subtitle }}</h3>

                  <!-- Frameworks -->
                  <h2 class="smaller-h2">Compliance Frameworks Covered:</h2>

                  <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Controls Implementation</h3>

                  @if (getSelectedFrameworks().length) {
                    <div class="frameworks">
                      <img *ngFor="let f of getSelectedFrameworks()"
                           [src]="f.value.imageUrl"
                           [alt]="f.value.name"
                           class="framework-image" />
                    </div>
                  }

                  <!-- Categories -->
                  <div class="categories" *ngFor="let category of getSelectedControlCategories()">
                    <ng-container *ngIf="hasResponses(category)">
                      <div class="category-bubble">
                        <h2>{{ category.get('name')?.value }}</h2>

                        <div class="control-item" *ngFor="let ci of getControlItemsControls(category)">
                          <div class="control-item-content"
                               *ngIf="ci.get('customResponse')?.value || ci.get('response')?.value">
                            <div class="control-item-header">
                              <strong>{{ ci.get('title')?.value }}</strong>
                            </div>
                            <div class="control-item-body">
                              <p>{{ ci.get('description')?.value }}</p>
                              <div class="status-indicator">
                                <ng-container *ngIf="ci.get('response')?.value">
                              <span *ngIf="ci.get('response')?.value === 'Custom' && ci.get('customResponse')?.value">
                                {{ ci.get('customResponse')?.value }}
                              </span>
                                  <ng-container *ngIf="ci.get('response')?.value !== 'Custom'">
                                    <span *ngIf="ci.get('response')?.value === 'Yes'" class="circle green"></span>
                                    <span *ngIf="ci.get('response')?.value === 'N/A'" class="circle gray"></span>
                                    <span *ngIf="ci.get('response')?.value === 'No'" class="circle red"></span>
                                  </ng-container>
                                </ng-container>

                                <div *ngIf="ci.get('showNote')?.value && ci.get('note')?.value" class="note-display">
                                  <em>{{ ci.get('note')?.value }}</em>
                                </div>
                              </div>


                            </div>

                            <div *ngIf="ci.get('evidences')?.value?.length" class="evidence-view mt-2">
                              <strong>Evidence:</strong>
                              <ul>
                                <li *ngFor="let ev of ci.get('evidences')?.value">
                                  <ng-container *ngIf="ev.base64Data">
                                    <a href="data:{{ev.mimeType}};base64,{{ev.base64Data}}"
                                       download="{{ev.name}}">
                                      {{ ev.name }}
                                    </a>
                                  </ng-container>
                                </li>
                              </ul>
                            </div>


                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Documentation</h3>
                  <div class="category-bubble">
                    <div>
                      <div class="personnel-row no-page-break">
                        <div class="personnel-info-cell no-page-break">
                          <div class="control-item">
                            <div class="control-item-content">
                              <div class="control-item-header"><strong>Policies &amp; Procedures</strong></div>
                              <div>
                                {{ trustReport.policiesAndProceduresNote }}
                              </div>
                              <div
                                style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                                @for (file of policiesAndProcedures; track file.name) {
                                  <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                                    <a target="_blank"
                                       [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                       style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                        <span
                                          style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                      style="flex: 0 0 auto;">.{{ file.extension }}</span>
                                    </a>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="personnel-row no-page-break">
                        <div class="personnel-info-cell no-page-break">
                          <div class="control-item">
                            <div class="control-item-content">
                              <div class="control-item-header"><strong>Assessments &amp; Authorizations</strong></div>
                              {{ trustReport.assessmentsAndAuthorizationsNote }}
                              <div
                                style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                                @for (file of assessmentsAndAuthorizations; track file.name) {
                                  <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                                    <a target="_blank"
                                       [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                       style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                        <span
                                          style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                      style="flex: 0 0 auto;">.{{ file.extension }}</span>
                                    </a>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div class="personnel-row no-page-break">
                        <div class="personnel-info-cell no-page-break">
                          <div class="control-item">
                            <div class="control-item-content">
                              <div class="control-item-header"><strong>Security Plans</strong></div>
                              {{ trustReport.securityPlansNote }}
                              <div
                                style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                                @for (file of securityPlans; track file.name) {
                                  <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                                    <a target="_blank"
                                       [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                                       style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                      <span
                                        style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                                      style="flex: 0 0 auto;">.{{ file.extension }}</span>
                                    </a>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="control-item">
                      <div class="control-item-content">
                        <div class="control-item-header"><strong>
                          @if (trustReport.planOfActionAndMilestones) {
                            <a
                              [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.planOfActionAndMilestones) + '&tenantName=' + tenantName">
                              Plan of Action &amp; Milestones
                            </a>
                          } @else {
                            Plan of Action &amp; Milestones
                          }
                        </strong></div>
                        <div>
                          {{ trustReport.planOfActionAndMilestonesNote }}
                        </div>
                        <div>
                          @if (trustReport.planOfActionAndMilestones) {
                            <img style="max-width: 1200px;"
                                 [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.planOfActionAndMilestones) + '&asImage=true&tenantName=' + tenantName" />
                          }
                        </div>
                      </div>
                    </div>

                    <div class="control-item">
                      <div class="control-item-content">
                        <div class="control-item-header"><strong>
                          @if (trustReport.incidentReports) {
                            <a
                              [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.incidentReports) + '&tenantName=' + tenantName">
                              Incident Reports
                            </a>
                          } @else {
                            Incident Reports
                          }
                        </strong></div>
                        <div>
                          {{ trustReport.incidentReportsNote }}
                        </div>
                        <div>
                          @if (trustReport.incidentReports) {
                            <img style="max-width: 1200px;"
                                 [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.incidentReports) + '&asImage=true&tenantName=' + tenantName" />
                          }
                        </div>
                      </div>
                    </div>

                    <div class="control-item">
                      <div class="control-item-content">
                        <div class="control-item-header"><strong>
                          @if (trustReport.listOfDeployedAuthorizedServices) {
                            <a
                              [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.listOfDeployedAuthorizedServices) + '&tenantName=' + tenantName">
                              List of Deployed Authorized Services
                            </a>
                          } @else {
                            List of Deployed Authorized Services
                          }
                        </strong></div>
                        <div>
                          {{ trustReport.listOfDeployedAuthorizedServicesNote }}
                        </div>
                        <div>
                          @if (trustReport.listOfDeployedAuthorizedServices) {
                            <img style="max-width: 1200px;"
                                 [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.listOfDeployedAuthorizedServices) + '&asImage=true&tenantName=' + tenantName" />
                          }
                        </div>
                      </div>
                    </div>

                    <div class="control-item">
                      <div class="control-item-content">
                        <div class="control-item-header"><strong>
                          @if (trustReport.additionalInformation) {
                            <a
                              [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.additionalInformation) + '&tenantName=' + tenantName">
                              Additional Information
                            </a>
                          } @else {
                            Additional Information
                          }
                        </strong></div>
                        <div>
                          {{ trustReport.additionalInformationNote }}
                        </div>
                        <div>
                          @if (trustReport.additionalInformation) {
                            <img style="max-width: 1200px;"
                                 [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.additionalInformation) + '&asImage=true&tenantName=' + tenantName" />
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Responsible Parties</h3>
                  <div class="personnel-grid no-page-break category-bubble">

                    <div class="personnel-row no-page-break" *ngFor="let section of [
    { title: 'Company Owners', data: formGroup.value.personnel.companyOwners },
    { title: 'Compliance Advisors', data: formGroup.value.personnel.complianceAdvisors },
    { title: 'Third Party Assessor/Auditor', data: formGroup.value.personnel.thirdPartyAssessors }
  ]">

                      <div class="personnel-logo-cell no-page-break">
                        <img [src]="section.data.imageUrl || 'assets/placeholder.png'"
                             alt="{{ section.title }} Logo"
                             class="personnel-logo" />
                      </div>

                      <div class="personnel-info-cell no-page-break">
                        <h3>{{ section.title }}</h3>
                        <div *ngFor="let p of section.data.people">
                          {{ p.name }}: {{ p.role }}
                        </div>
                      </div>

                    </div>
                  </div>


                  <div class="report-disclaimer" *ngIf="formGroup.get('disclaimer')?.value">
                    <hr />
                    <p><strong>Disclaimer:</strong> {{ formGroup.get('disclaimer')?.value }}</p>
                  </div>
                  <div class="report-footer no-page-break" style="text-align: center; margin-top: 50px;">
                    <img src="../../../assets/icon/favicon-96x96.png" alt="Rizkly Logo"
                         style="height: 40px; margin-bottom: 5px;" />
                    <div>Powered by Rizkly</div>
                    <div>Generated on {{ today | date:'MM/dd/yy' }}</div>
                  </div>
                  <br />
                </div>
                <div class="actions">
                  <button mat-raised-button matStepperPrevious type="button">Back</button>
                  <button mat-raised-button matStepperNext type="button">Next</button>
                  <button mat-raised-button (click)="onDone()">Save</button>
                  <button mat-raised-button (click)="saveAsPDF()">Save to PDF</button>
                  <button mat-raised-button (click)="saveAsHTMLZip()">Save to HTML Zip</button>
                </div>
                <br />
              </mat-step>

            </mat-horizontal-stepper>
          </div>
        </mat-tab>
        <mat-tab label="Users" *ngIf="trustReport?.id">
          <div style="margin-top: 20px;" class="controls">
            <button mat-raised-button (click)="invite()">Manage Users</button>
          </div>

          <p-table [value]="viewerUsers"
                   [paginator]="false"
                   [style]="{'margin-top':'10px'}"
                   selectionMode="multiple"
                   [(selection)]="assignedUsers"
          >
            <ng-template pTemplate="header">
              <tr [ngStyle]="{'white-space': 'nowrap'}">
                <th style="width: 3em; padding: 0.5rem;">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Company</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td>{{ getFullName(item) }}</td>
                <td>{{ item.emailAddress }}</td>
                <td>{{ item.companyName }}</td>
              </tr>
            </ng-template>
          </p-table>
          <button mat-raised-button (click)="onDone()">Save</button>
          <br />
          <h4>Email Users</h4>
          <p-editor matInput
                    type="text"
                    name="references"
                    [(ngModel)]="inviteText"
                    #description="ngModel"
                    style="max-width: calc(100vw - 300px)">
            <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
              <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
              <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
              <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                    <button class="ql-indent" value="-1"></button>
                    <button class="ql-indent" value="+1"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                <!--button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                        (click)="selectDocument(el)">D</button-->
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
              <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
            </p-header>
          </p-editor>

          <div style="margin-top: 20px;" class="controls">
            <button mat-raised-button (click)="sendInvite()">Invite</button>
          </div>
          <div style="margin-top: 20px;" class="controls">
            <button mat-raised-button (click)="onDone()">Save</button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div *ngIf="activeTab === 'forms'" style="overflow: auto;" class="p-4 flex flex-column gap-4 scrollable-step-content">

    <!-- Header -->
    <div>
      <h4 class="mb-1">Compliance Survey Auto-Population</h4>
      <p class="text-sm text-color-secondary">
        Upload a compliance questionnaire (Excel or Word). Questions will be parsed,
        matched against existing trust content, and auto-populated where possible.
      </p>
    </div>

    <!-- Upload Card -->
    <div class="p-card p-3">
      <h5 class="mb-2">1. Upload Survey</h5>

      <input type="file"
             accept=".csv,.xlsx,.docx"
             (change)="onSurveyUpload($event)"
             style="display:none"
             #surveyInput>
      <button mat-stroked-button color="primary" (click)="surveyInput.click()">
        Upload Survey
      </button>
      <small class="text-color-secondary">
        Supported formats: .xlsx, .docx (template-based parsing)
      </small>
    </div>

    <!-- Survey Info -->
    <div class="p-card p-3" *ngIf="surveyLoaded">
      <h5 class="mb-3">2. Survey Details</h5>

      <div class="grid">
        <div class="col-6">
          <label class="block mb-1">Survey Name</label>
          <input pInputText [(ngModel)]="survey.name" />
        </div>

        <div class="col-6">
          <label class="block mb-1">Source File</label>
          <input pInputText [value]="survey.fileName" disabled />
        </div>
      </div>
    </div>

    <!-- Match Summary -->
    <div class="p-card p-3" *ngIf="surveyLoaded">
      <h5 class="mb-2">3. Auto-Population Summary</h5>

      <div class="flex gap-4">
        <div>
          <strong>{{ matchSummary.total }}</strong><br />
          <small>Total Questions</small>
        </div>
        <div>
          <strong class="text-green-600">{{ matchSummary.matched }}</strong><br />
          <small>Matched</small>
        </div>
        <div>
          <strong class="text-orange-500">{{ matchSummary.unmatched }}</strong><br />
          <small>Needs Review</small>
        </div>
      </div>
    </div>

    <!-- Questions Table -->
    <div class="p-card p-3" *ngIf="surveyLoaded">
      <h5 class="mb-3">4. Parsed Questions</h5>

      <p-table [value]="survey.questions"
               [paginator]="true"
               [rows]="100"
               scrollable="true"
               scrollHeight="400px"
               responsiveLayout="scroll">

        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>Question</th>
            <th>Matched Trust Item</th>
            <th>Response</th>
            <th>Status</th>
            <th>Confidence</th>
            <th style="width: 60px;"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-q let-i="rowIndex">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ q.text }}</td>

            <td>
                <span *ngIf="q.matched">
                  {{ q.matchedItem }}
                </span>
              <span *ngIf="!q.matched" class="text-color-secondary">
                  -
                </span>
            </td>

            <td>
              <ng-container *ngIf="q.matched; else noResponse">
                <input type="text"
                       pInputText
                       [(ngModel)]="q.autoFilledResponse"
                       class="w-full" />
              </ng-container>

              <ng-template #noResponse>
                <span class="text-color-secondary">-</span>
              </ng-template>
            </td>

            <td>
              <span *ngIf="q.matched" class="text-green-600">Matched</span>
              <span *ngIf="!q.matched" class="text-orange-500">Unmatched</span>
            </td>


            <td>
                <span *ngIf="q.matched">
                  {{ q.confidence | percent:'1.0-0' }}
                </span>
              <span *ngIf="!q.matched">-</span>
            </td>

            <td class="text-center">
              <button pButton
                      type="button"
                      icon="pi pi-trash"
                      class="p-button-text p-button-danger"
                      (click)="removeSurveyQuestion(i)"
                      aria-label="Delete question"></button>
            </td>


          </tr>
        </ng-template>

      </p-table>
    </div>

    <!-- Actions -->
    <div class="flex justify-content-end gap-2" *ngIf="surveyLoaded">
      <button pButton
              label="Download Filled Survey"
              icon="pi pi-save"
              class="p-button-secondary"
              (click)="downloadSurvey()">
      </button>

      <button pButton
              label="Save Populated Survey"
              icon="pi pi-save"
              (click)="saveSurvey()">
      </button>
    </div>

  </div>

  @if (activeTab === 'external') {
    <div style="padding: 20px;">
      <div>
        @if (settings.trustReportLogo) {
          <img style="max-width: 100px; max-height: 100px;"
               [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(settings.trustReportLogo) + '&asImage=true&tenantName=' + tenantName" />
        }
        <label class="mat-button mat-raised-button" for="updateLogo">
          <i class="pi pi-paperclip"></i>
          <p class="clip-text">Upload new file</p>
          <input id="updateLogo" type="file" accept=".pdf,image/*"
                 (change)="addLogo($event)" name="updateLogo"
                 style="display: none;" />
        </label>
        @if (settings.trustReportLogo) {
          <label class="mat-button mat-raised-button" mwlConfirmationPopover
                 [title]="'Remove Logo'"
                 [popoverMessage]="'You are going to remove Logo. Are you sure?'"
                 [appendToBody]="true" [confirmText]="'Yes'" [cancelText]="'No'" placement="top"
                 (confirm)="settings.trustReportLogo=null">
            <i class="pi pi-trash"></i>
            <p class="clip-text"> Remove Logo</p>
          </label>
        }
      </div>
      <div>
        <mat-form-field style="width: 500px;">
          <mat-label>Company Name</mat-label>
          <input type="text" matInput [(ngModel)]="settings.trustReportCompanyName" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field style="width: 500px;">
          <mat-label>Authorized Product Name</mat-label>
          <input type="text" matInput [(ngModel)]="settings.trustReportProductName" />
        </mat-form-field>
      </div>
      <div>
        <mat-label>Description of Authorized Services</mat-label>
        <p-editor matInput
                  type="text"
                  name="references"
                  [(ngModel)]="settings.trustReportDescription"
                  #description="ngModel"
                  style="max-width: calc(100vw - 300px)">
          <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
            <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
            <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                    <button class="ql-indent" value="-1"></button>
                    <button class="ql-indent" value="+1"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
              <!--button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                      (click)="selectDocument(el)">D</button-->
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
          </p-header>
        </p-editor>
      </div>
      <div>
        <mat-form-field style="width: 500px;">
          <mat-label>Link to Authorization Listing</mat-label>
          <input type="text" matInput [(ngModel)]="settings.trustReportListingLink" />
        </mat-form-field>
      </div>
      <div>
        <mat-label>Instructions for accessing authorization information i.e. Trust Report</mat-label>
        <p-editor matInput
                  type="text"
                  name="references"
                  [(ngModel)]="settings.trustReportInstructions"
                  #description="ngModel"
                  style="max-width: calc(100vw - 300px)">
          <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
            <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
            <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                    <button class="ql-indent" value="-1"></button>
                    <button class="ql-indent" value="+1"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
              <!--button aria-label="Document" class="custom-button" style="font-size: 1.3em;margin-top: -3px;" #el
                      (click)="selectDocument(el)">D</button-->
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
            <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
          </p-header>
        </p-editor>
      </div>
      <div>
        <mat-checkbox [(ngModel)]="settings.trustReportIsPublished">Publish</mat-checkbox>
        @if (settings.trustReportIsPublished) {
          <div style="margin-left: 20px; padding: 5px;">
            <a [routerLink]="['/trustReport']">Link</a>
          </div>
        }
      </div>
      <div>
        <button pButton
                label="Save"
                icon="pi pi-save"
                class="p-button-secondary"
                (click)="saveSettings()">
        </button>
      </div>
    </div>
  }

</div>
